"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.anySchemaPermission = exports.surveyPartPermission = exports.extraSurveyPartPermission = exports.surveySchemaPermission = exports.surveyOverviewPermissionForAnySurvey = exports.surveyOverviewPermission = exports.summaryPermission = exports.openEndedQuestionsPermission = exports.dimensionsPermission = exports.participantsWritePermissionForAnySurvey = exports.participantsWritePermission = exports.participantsReadPermission = exports.researchUserPermission = exports.exportPermission = exports.manageAnySurveyPermissionExceptHUS = exports.manageSurveyPermission = exports.manageAnySurveyPermission = exports.userAdminWritePermission = exports.userAdminViewPermission = exports.adminPermission = exports.hasAllPermissions = exports.hasSomePermission = exports.hasPermission = exports.decodePermissions = exports.encodePermissions = exports.surveyTypeToPermissionType = exports.SurveyType = exports.PermissionType = exports.PermissionName = void 0;
/**
 * Permission names available in UniHow
 */
var PermissionName;
(function (PermissionName) {
    PermissionName["USER_ADMIN"] = "USER_ADMIN";
    PermissionName["MANAGE_SURVEY"] = "MANAGE_SURVEY";
    PermissionName["DIMENSIONS"] = "DIMENSIONS";
    PermissionName["SUMMARY"] = "SUMMARY";
    PermissionName["PARTICIPANTS"] = "PARTICIPANTS";
    PermissionName["OPEN_ENDED_QUESTIONS"] = "OPEN-ENDED_QUESTIONS";
    PermissionName["EXPORT"] = "EXPORT";
    PermissionName["RESEARCH_USER"] = "RESEARCH_USER";
    PermissionName["SURVEY_SCHEMA"] = "SURVEY_SCHEMA";
    PermissionName["SURVEY_PART"] = "SURVEY_PART";
    PermissionName["EXTRA_SURVEY_PART"] = "EXTRA_SURVEY_PART";
})(PermissionName || (exports.PermissionName = PermissionName = {}));
;
/**
 * Permission types categorizing the permission context
 */
var PermissionType;
(function (PermissionType) {
    PermissionType["ADMIN"] = "ADMIN";
    PermissionType["SCHEMA"] = "SCHEMA";
    PermissionType["HUL"] = "HUL";
    PermissionType["HUS"] = "HUS";
    PermissionType["HUP"] = "HUP";
    PermissionType["HUT"] = "HUT";
})(PermissionType || (exports.PermissionType = PermissionType = {}));
;
/**
 * Survey types available in UniHow
 */
var SurveyType;
(function (SurveyType) {
    SurveyType["DEGREE_PROGRAM_SURVEY"] = "DEGREE_PROGRAM_SURVEY";
    SurveyType["COURSE_SURVEY"] = "COURSE_SURVEY";
    SurveyType["HUP"] = "HUP";
    SurveyType["HUT"] = "HUT";
})(SurveyType || (exports.SurveyType = SurveyType = {}));
;
/**
 * Maps a survey type into a permission type
 */
exports.surveyTypeToPermissionType = {
    [SurveyType.DEGREE_PROGRAM_SURVEY]: PermissionType.HUL,
    [SurveyType.COURSE_SURVEY]: PermissionType.HUS,
    [SurveyType.HUP]: PermissionType.HUP,
    [SurveyType.HUT]: PermissionType.HUT
};
;
;
/**
 * Encodes an array of UserPermission objects into compact strings for session cookie storage.
 * Each permission becomes "PERMISSION_NAME:PERMISSION_TYPE:WRITE" (e.g. "MANAGE_SURVEY:HUL:1").
 *
 * This reduces cookie size by ~4x, keeping the session under the browser's 4KB cookie limit
 * for users with many permissions.
 */
const encodePermissions = (permissions) => permissions.map(p => `${p.permission_name}:${p.permission_type}:${p.write_permission ? 1 : 0}`);
exports.encodePermissions = encodePermissions;
/**
 * Decodes compact permission strings back into UserPermission objects.
 * Reverses encodePermissions; used when reading permissions from the session cookie.
 * Throws an Error if any encoded string is malformed or contains unknown enum values.
 */
const decodePermissions = (encoded) => {
    const validNames = new Set(Object.values(PermissionName));
    const validTypes = new Set(Object.values(PermissionType));
    return encoded.map(entry => {
        const parts = entry.split(':');
        if (parts.length !== 3) {
            throw new Error(`Invalid encoded permission (expected 3 parts): "${entry}"`);
        }
        const [name, type, write] = parts;
        if (!validNames.has(name)) {
            throw new Error(`Invalid PermissionName in encoded permission: "${name}"`);
        }
        if (!validTypes.has(type)) {
            throw new Error(`Invalid PermissionType in encoded permission: "${type}"`);
        }
        if (write !== '0' && write !== '1') {
            throw new Error(`Invalid write_permission value in encoded permission (expected "0" or "1"): "${write}"`);
        }
        return {
            permission_name: name,
            permission_type: type,
            write_permission: write === '1',
        };
    });
};
exports.decodePermissions = decodePermissions;
/**
 * Core check: verifies if any UserPermission satisfies the requiredPermission criteria.
 * Returns false if requiredPermission is undefined or has neither name or type.
 * - If permission_name is set, it must match.
 * - If permission_type is set, it must match.
 * - If write_permission=true, user permission must also have write_permission=true.
 */
const hasPermission = (userPermissions, requiredPermission) => {
    if (!(requiredPermission === null || requiredPermission === void 0 ? void 0 : requiredPermission.permission_name) && !(requiredPermission === null || requiredPermission === void 0 ? void 0 : requiredPermission.permission_type)) {
        return false;
    }
    const { permission_name, permission_type, write_permission = false } = requiredPermission;
    return userPermissions.some(p => (permission_name === undefined || p.permission_name === permission_name) &&
        (permission_type === undefined || permission_type === p.permission_type) &&
        (!write_permission || p.write_permission));
};
exports.hasPermission = hasPermission;
/**
 * Checks if user has at least one of the required permissions
 */
const hasSomePermission = (userPermissions, requiredPermissions) => (requiredPermissions.some(required => (0, exports.hasPermission)(userPermissions, required)));
exports.hasSomePermission = hasSomePermission;
/**
 * Checks that user has all of the required permissions
 */
const hasAllPermissions = (userPermissions, requiredPermissions) => (requiredPermissions.every(required => (0, exports.hasPermission)(userPermissions, required)));
exports.hasAllPermissions = hasAllPermissions;
/**
 * Generates a permission object for the given survey type.
 */
const _makeSurveyTypePermission = (surveyType, permission_name, write_permission = false) => {
    const permission_type = exports.surveyTypeToPermissionType[surveyType];
    if (!permission_type)
        throw new Error(`Invalid survey type: ${surveyType}`);
    return permission_name
        ? { permission_name, permission_type, write_permission }
        : { permission_type, write_permission };
};
// Admin permissions
const adminPermission = () => ({
    permission_type: PermissionType.ADMIN, write_permission: true
});
exports.adminPermission = adminPermission;
const userAdminViewPermission = () => ({
    permission_name: PermissionName.USER_ADMIN,
    permission_type: PermissionType.ADMIN,
});
exports.userAdminViewPermission = userAdminViewPermission;
const userAdminWritePermission = () => ({
    permission_name: PermissionName.USER_ADMIN,
    permission_type: PermissionType.ADMIN,
    write_permission: true
});
exports.userAdminWritePermission = userAdminWritePermission;
// Survey permissions
const manageAnySurveyPermission = () => ({
    permission_name: PermissionName.MANAGE_SURVEY, write_permission: true
});
exports.manageAnySurveyPermission = manageAnySurveyPermission;
const manageSurveyPermission = (surveyType) => (_makeSurveyTypePermission(surveyType, PermissionName.MANAGE_SURVEY, true));
exports.manageSurveyPermission = manageSurveyPermission;
const manageAnySurveyPermissionExceptHUS = () => {
    const allowedTypes = Object.values(SurveyType)
        .filter(type => type !== SurveyType.COURSE_SURVEY);
    return allowedTypes.map(type => _makeSurveyTypePermission(type, PermissionName.MANAGE_SURVEY, true));
};
exports.manageAnySurveyPermissionExceptHUS = manageAnySurveyPermissionExceptHUS;
const exportPermission = (surveyType) => (_makeSurveyTypePermission(surveyType, PermissionName.EXPORT, false));
exports.exportPermission = exportPermission;
const researchUserPermission = (surveyType) => (_makeSurveyTypePermission(surveyType, PermissionName.RESEARCH_USER));
exports.researchUserPermission = researchUserPermission;
const participantsReadPermission = (surveyType) => (_makeSurveyTypePermission(surveyType, PermissionName.PARTICIPANTS, false));
exports.participantsReadPermission = participantsReadPermission;
const participantsWritePermission = (surveyType) => (_makeSurveyTypePermission(surveyType, PermissionName.PARTICIPANTS, true));
exports.participantsWritePermission = participantsWritePermission;
const participantsWritePermissionForAnySurvey = () => ({
    permission_name: PermissionName.PARTICIPANTS, write_permission: true
});
exports.participantsWritePermissionForAnySurvey = participantsWritePermissionForAnySurvey;
const dimensionsPermission = (surveyType) => (_makeSurveyTypePermission(surveyType, PermissionName.DIMENSIONS));
exports.dimensionsPermission = dimensionsPermission;
const openEndedQuestionsPermission = (surveyType) => (_makeSurveyTypePermission(surveyType, PermissionName.OPEN_ENDED_QUESTIONS));
exports.openEndedQuestionsPermission = openEndedQuestionsPermission;
const summaryPermission = (surveyType) => (_makeSurveyTypePermission(surveyType, PermissionName.SUMMARY));
exports.summaryPermission = summaryPermission;
/**
 * Lowest level survey permission check, checks for any survey type permission.
 * Technically equivalent to SUMMARY permission
 */
const surveyOverviewPermission = (surveyType) => (_makeSurveyTypePermission(surveyType));
exports.surveyOverviewPermission = surveyOverviewPermission;
const surveyOverviewPermissionForAnySurvey = () => (Object.values(SurveyType).map(type => _makeSurveyTypePermission(type)));
exports.surveyOverviewPermissionForAnySurvey = surveyOverviewPermissionForAnySurvey;
// Schema permissions
const surveySchemaPermission = (write = false) => ({
    permission_name: PermissionName.SURVEY_SCHEMA,
    permission_type: PermissionType.SCHEMA,
    write_permission: write
});
exports.surveySchemaPermission = surveySchemaPermission;
const extraSurveyPartPermission = (write = false) => ({
    permission_name: PermissionName.EXTRA_SURVEY_PART,
    permission_type: PermissionType.SCHEMA,
    write_permission: write
});
exports.extraSurveyPartPermission = extraSurveyPartPermission;
const surveyPartPermission = (write = false) => ({
    permission_name: PermissionName.SURVEY_PART,
    permission_type: PermissionType.SCHEMA,
    write_permission: write
});
exports.surveyPartPermission = surveyPartPermission;
const anySchemaPermission = () => ({ permission_type: PermissionType.SCHEMA });
exports.anySchemaPermission = anySchemaPermission;
